class EventBus {
  constructor() {
    this.events = {};
    this.stickyEvents = {};
  }

  on(eventName, callback, executeSticky = true) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);

    // 如果有粘性事件，并且 executeSticky 为 true，立即执行
    if (executeSticky && this.stickyEvents[eventName]) {
      callback(this.stickyEvents[eventName]);
    }
  }

  emit(eventName, data, sticky = true) {
    // 如果 sticky 为 true，保存最新的事件数据
    if (sticky) {
      this.stickyEvents[eventName] = data;
    }

    const event = this.events[eventName];
    if (event) {
      event.forEach(callback => callback(data));
    }
  }

  // 清除特定事件的所有监听器
  off(eventName) {
    delete this.events[eventName];
  }

  // 清除特定事件的粘性数据
  clearSticky(eventName) {
    delete this.stickyEvents[eventName];
  }

  // 获取特定事件的粘性数据
  getStickyEvent(eventName) {
    return this.stickyEvents[eventName];
  }
}

export default new EventBus();